import FMCTextarea from '@ford/ford-design-system/src/web-components/fmc-forms/src/FMCTextarea.js';
import { css } from 'lit';

export default class RepoFMCTextarea extends FMCTextarea {
  constructor() {
    super();
    this.rows = 6; // Override rows to 6 instead of 4
  }
  static get styles() {
    return [
      css`
        :host {
          --shadow: none;
          --shadow-hover: var(--fmc-elevation__box-shadow--layer3);
          --background-color: transparent;
          --background-color-focus: var(--fds-color--white);
          --border-color: var(--fds-color--gray2);
          --text-color: var(--fds-color--primary);
          --text-color-disabled: var(--fds-color--white);
          --placeholder-text-color: var(--fds-color--gray3);
          --placeholder-letter-spacing: 0.1rem;
          --border-weight: 0.1rem;
          --border-bottom-weight: 0.1rem;
          --border-bottom-weight-focus: 0.2rem;
          --border-all: 0.1rem solid var(--border-color);
          --border-bottom: var(--border-all);
          --border-bottom-focus: var(--border-all);
          --border-radius: 0.3rem;
          --padding-left: 1.6rem;
          --padding-top: 1.6rem;
          --padding-right: var(--padding-left);
          --padding-bottom: var(--padding-top);
        }

        :host([brand='lincoln']) {
          --border-color: var(--fds-color--primary);
          --border-color-focus: var(--fds-color--secondary);
          --border-radius: 0;
          --border-all: none;
          --border-bottom: var(--border-bottom-weight) solid var(--border-color);
          --background-color: var(--fds-color--gray2);
          --background-color-focus: var(--fds-color--gray2);
          --border-bottom-focus: var(--border-bottom-weight) solid var(--border-color-focus);
          --shadow-hover: none;
          --height: 6rem;
          --padding-left: 1.4rem;
          --padding-top: 3rem;
          --placeholder-text-color: var(--fds-color--primary);
          --placeholder-letter-spacing: 0;
        }

        :host([status='error']) {
          --border-color: var(--fds-color--error1);
        }

        :host([status='success']) {
          --border-color: var(--fds-color--success1);
        }

        textarea {
          display: block;
          width: 100%;
          padding: var(--padding-top) var(--padding-right) var(--padding-bottom) var(--padding-left);
          font-size: 2.4rem;
          color: var(--text-color);
          border: var(--border-all);
          border-bottom: var(--border-bottom);
          border-radius: var(--border-radius);
          background-color: var(--background-color);
          background-repeat: no-repeat;
          background-position: right 1.5rem center;
          background-size: 16px;
          line-height: 2rem;
          appearance: none;
          outline-offset: var(--fds-outline-offset);
          box-shadow: var(--shadow);
          will-change: box-shadow;
          box-sizing: border-box;
          transition:
            box-shadow 0.3s ease-in-out,
            background-color 0.3s ease-in-out;
        }

        textarea:focus,
        textarea:focus-visible {
          --shadow: var(--shadow-hover);
          --background-color: var(--background-color-focus);
          --border-bottom-weight: var(--border-bottom-weight-focus);
          --border-bottom: var(--border-bottom-focus);

          outline: none;
        }
      `,
    ];
  }
}
customElements.define('repo-fmc-textarea', RepoFMCTextarea);
